const MARKETING_HOSTS = new Set([
  "nexoprint.app",
  "www.nexoprint.app",
  "app.nexoprint.app",
  "nexoprint.localhost",
]);

export function isMarketingHostname(value) {
  if (
    typeof window !== "undefined" &&
    import.meta.env.DEV &&
    new URLSearchParams(window.location.search).get("landing") === "1"
  ) {
    return true;
  }

  const hostname = String(
    value || (typeof window !== "undefined" ? window.location.hostname : "")
  )
    .trim()
    .toLowerCase();
  return MARKETING_HOSTS.has(hostname);
}
